import React from "react";
import ColorInit from "../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import Preloader from "../helper/Preloader";
import HeaderOne from "../components/HeaderOne";
import BreadcrumbThree from "../components/BreadcrumbThree";
import VendorsList from "../components/VendorsList";
import ShippingOne from "../components/ShippingOne";
import NewsletterOne from "../components/NewsletterOne";
import FooterOne from "../components/FooterOne";
import BottomFooter from "../components/BottomFooter";
import { Helmet } from "react-helmet-async";

const VendorPage = () => {
  return (
    <>
 
      <Helmet>
        <title> Vendors | VillageZone - Your Destination for Healthy, Preservative-Free, Handcrafted Goodness</title>
      </Helmet>

      {/* BreadcrumbThree */}
      <BreadcrumbThree title={"Vendor List"} />

      {/* VendorsList */}
      <VendorsList />

      {/* ShippingOne */}
      <ShippingOne />

    </>
  );
};

export default VendorPage;
